const workFlow = {
  state: {
    handle: 0,
    all: 0,
    initiate: 0,
    done: 0,
    paused: 0,
    unread: 0,
    upcoming: 0,
    unprocessed: 0,
    myunfinished: 0,
    message: 0,
    warning: 0,
    hasTodo: false,
    stamp: 0,
    topStamp: 0,
    currentType: 1
  },
  mutations: {
    CHANGE_CURRENTTYPE: (state, currentType) => {
      state.currentType = currentType
    },
    CHANGE_TOPSTAMP: (state, topStamp) => {
      state.topStamp = topStamp
    },
    CHANGE_STAMP: (state, stamp) => {
      state.stamp = stamp
    },
    CHANGE_HASTODO: (state, status) => {
      state.hasTodo = status
    },
    CHANGE_STATE: (state, data) => {
      state[data.key] = data.value
    }
  },
  actions: {
    changeCurrentType({ commit }, currentType) {
      commit('CHANGE_CURRENTTYPE', currentType)
    },
    changeTopStamp({ commit }, topStamp) {
      commit('CHANGE_TOPSTAMP', topStamp)
    },
    changeStamp({ commit }, stamp) {
      commit('CHANGE_STAMP', stamp)
    },
    changeHasTodo({ commit }, status) {
      commit('CHANGE_HASTODO', status)
    },
    changeState({ commit }, data) {
      commit('CHANGE_STATE', data)
    }
  }
}

export default workFlow
